export default __webpack_public_path__ + "static/media/banner-contact.33e59d00.png";